import {
  animate,
  AnimationTriggerMetadata,
  style,
  transition,
  trigger
} from '@angular/animations';

export const slideInOut: AnimationTriggerMetadata = trigger('slideInOut', [
  transition(':enter', [
    style({ opacity: 0, transform: 'translateY(-10px) scaleY(0.95)' }),
    animate(
      '300ms ease-out',
      style({ opacity: 1, transform: 'translateY(0) scaleY(1)' })
    )
  ]),
  transition(':leave', [
    animate(
      '200ms ease-in',
      style({ opacity: 0, transform: 'translateY(-10px) scaleY(0.95)' })
    )
  ])
]);
